import React from 'react';

interface HighlightProps {
  highlightText: string;
  icon: 'coral' | 'royalBlue';
}

const Highlight: React.FC<HighlightProps> = ({ highlightText, icon }) => {
  const iconClass =
    icon === 'coral'
      ? 'before:bg-[url("/images/call-out-coral.svg")]'
      : 'before:bg-[url("/images/call-out-royal-blue.svg")]';

  return (
    <div
      className={`relative mt-5 flex items-center rounded-xl bg-white/30 p-5 pl-16 ${iconClass} before:absolute before:-left-2 before:h-[50px] before:w-12 before:bg-cover before:bg-no-repeat before:content-['']`}
    >
      <p className='text-xl font-semibold leading-7'>{highlightText}</p>
    </div>
  );
};

export default Highlight;
